<template>
  <div
    class="card card-img-bg"
    :style="`background-image: url(${article.getFolderImage()})`"
  >
    <div class="card-content">
      <h3 class="card-title"><a :href="article.getUrl()" v-html="$sanitize(article.getTitle())"></a></h3>
      <p v-if="article.getPublicationDate()" class="card-proposed-by">
        Publié le {{ article.getPublicationDate() }}
      </p>
      <a :href="article.getUrl()"
         rel="bookmark"
         class="link btn-arrow"
        ><span>Lire le dossier</span></a>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
